import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Lock, ArrowRight, CheckCircle } from 'lucide-react';
import api from '../services/api';
import toast from 'react-hot-toast';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();
  const [form, setForm] = useState({ newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) return toast.error('Passwords do not match');
    if (form.newPassword.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, newPassword: form.newPassword });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Reset failed — link may have expired');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', backgroundImage: 'radial-gradient(ellipse at 50% 0%, rgba(59,130,246,0.08) 0%, transparent 60%)' }}>
      <div style={{ width: '100%', maxWidth: 400, padding: '0 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--blue-dim)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>
            <Lock size={22} color="#93c5fd" />
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 600, letterSpacing: '-0.5px' }}>Set new password</h1>
          <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 6 }}>Enter your new password below</p>
        </div>

        {done ? (
          <div className="card" style={{ padding: 28, textAlign: 'center' }}>
            <CheckCircle size={40} color="var(--green)" style={{ marginBottom: 16 }} />
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Password reset!</h2>
            <p style={{ fontSize: 13, color: 'var(--text2)' }}>Redirecting you to login…</p>
          </div>
        ) : !token ? (
          <div className="card" style={{ padding: 28, textAlign: 'center' }}>
            <p style={{ color: 'var(--red)', fontSize: 14 }}>Invalid reset link. Please request a new one.</p>
            <button className="btn btn-primary" style={{ marginTop: 16 }} onClick={() => navigate('/login')}>Back to login</button>
          </div>
        ) : (
          <div className="card" style={{ padding: 28 }}>
            <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={{ fontSize: 12, color: 'var(--text2)', display: 'block', marginBottom: 6 }}>New password</label>
                <div style={{ position: 'relative' }}>
                  <Lock size={14} style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--text3)' }} />
                  <input className="input" type="password" placeholder="Min 6 characters" style={{ paddingLeft: 32 }} value={form.newPassword} onChange={e => setForm({ ...form, newPassword: e.target.value })} required minLength={6} />
                </div>
              </div>
              <div>
                <label style={{ fontSize: 12, color: 'var(--text2)', display: 'block', marginBottom: 6 }}>Confirm new password</label>
                <div style={{ position: 'relative' }}>
                  <Lock size={14} style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--text3)' }} />
                  <input className="input" type="password" placeholder="Repeat password" style={{ paddingLeft: 32 }} value={form.confirmPassword} onChange={e => setForm({ ...form, confirmPassword: e.target.value })} required />
                </div>
              </div>
              <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center', padding: '10px' }}>
                {loading ? 'Resetting…' : 'Reset password'} {!loading && <ArrowRight size={14} />}
              </button>
            </form>
          </div>
        )}
        <p style={{ textAlign: 'center', marginTop: 18, fontSize: 13, color: 'var(--text2)' }}>
          Remember it? <button onClick={() => navigate('/login')} style={{ background: 'none', border: 'none', color: 'var(--blue)', fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>Sign in</button>
        </p>
      </div>
    </div>
  );
}
